<template>
    <section style="margin: 18px;">
        <v-flex>
            <v-flex class="clsForTitles">
                <!-- <v-select item-value='_id' item-text='center_name' return-object v-model="SelectedCenter" :items="Admins" label="Select Center">
                    <template slot='selection' slot-scope='{ item }'>
                        {{ item.center_name }} ( {{ item.center_id }} )
                    </template>
                    <template slot='item' slot-scope='{ item }'>
                        {{ item.center_name }} ( {{ item.center_id }} ) 
                    </template>
                </v-select> -->
                <v-autocomplete v-model="SelectedCenter" :items="Admins" 
                                :filter="customFilter" color="primary" 
                                item-text="center_name" return-object label="Select Center">
                     <template slot='selection' slot-scope='{ item }'>
                        {{ item.center_name }} ( {{ item.center_id }} )
                    </template>
                    <template slot='item' slot-scope='{ item }'>
                        {{ item.center_name }} ( {{ item.center_id }} ) 
                    </template>
                </v-autocomplete>
            </v-flex>   
            <v-flex class="clsForTitles"> 
             <v-menu v-model="date_menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y
                            min-width="290px">
                <template v-slot:activator="{ on }">
                <v-text-field v-model="exam_date" label="Pick Exam Date" prepend-icon="event" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="exam_date" @input="GetExamList"></v-date-picker>
            </v-menu>
            </v-flex>
            <v-flex class="clsForTitles">
                <v-select item-value='_id' item-text='exam_name' return-object v-model="SelectedExam" @change="GetStudentList" :items="exam_list" label="Select Exams">
                    <template slot='selection' slot-scope='{ item }'>
                        {{ item.exam_name }} ( {{ item.start_time }} - {{ item.exam_id }})
                    </template>
                    <template slot='item' slot-scope='{ item }'>
                        {{ item.exam_name }} ( {{ item.start_time }} - {{ item.exam_id }}) 
                    </template>
                </v-select>
            </v-flex>
        </v-flex>
           <v-data-table :headers="headers" :items="StudentList" hide-actions disable-initial-sort height="inherit" item-key="_id" class="elevation-1">
            <template v-slot:headers="props">
                <tr>
                <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                <td class="text-xs-center">{{ props.item.first_name }}</td>
                <td class="text-xs-center">{{ props.item.last_name }}</td>
                <td class="text-xs-center">{{ props.item.exam_id }}</td>
                <td class="text-xs-center">{{ props.item.datetime | moment("DD-MM-YYYY,hh:mm a") }}</td>
                <td class="text-xs-center">{{ props.item.login_time | moment("DD-MM-YYYY,hh:mm a") }}</td>
                <td class="text-xs-center">{{ props.item.last_disconnected | moment("DD-MM-YYYY,hh:mm a") }}</td>
                <td class="text-xs-center">{{ props.item.submit_time | moment("DD-MM-YYYY,hh:mm a")  }}</td>
                <td class="text-xs-center">{{ props.item.submit_status ? 'Submitted' : 'Not Submitted'}}</td>
                <td class="text-xs-center">
                    <v-icon class="clsForActions" color="primary" @click="MoreDetails(props.item)" dark>more</v-icon>
                </td>
                </tr>
            </template>
            </v-data-table>
            <v-dialog v-model="dialog" persistent max-width="700">
                <v-card>
                    <v-card-title class="headline grey lighten-3" primary-title>
                        <v-flex>Student Details</v-flex>
                        <v-flex style="padding: 0px 20px;">
                            <v-icon @click="CloseDialog" style="float:right;">close</v-icon>
                        </v-flex>
                    </v-card-title>
                    <v-card-text>
                        <v-flex >
                            <v-flex class="clsForStudentDetails"><b>First Name</b> : {{ student_details.first_name }}</v-flex>
                            <v-flex class="clsForStudentDetails"><b>Last Name</b> : {{ student_details.last_name }}</v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex class="clsForStudentDetails"><b>Email</b> : {{ student_details.email }}</v-flex>
                            <v-flex class="clsForStudentDetails"><b>Id</b> : {{ student_details.id }}</v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex class="clsForStudentDetails"><b>Exam Date</b> : {{ student_details.datetime | moment("DD-MM-YYYY,hh:mm a") }}</v-flex>
                            <v-flex class="clsForStudentDetails"><b>Center Id</b> : {{ student_details.center_id }}</v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex class="clsForStudentDetails"><b>Class</b> : {{ student_details.class }}</v-flex>
                            <v-flex class="clsForStudentDetails"><b>DOB</b> : {{ student_details.dob | moment("DD-MM-YYYY,hh:mm a") }}</v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex class="clsForStudentDetails"><b>Password</b> : {{ student_details.password }}</v-flex>
                            <v-flex class="clsForStudentDetails"><b>Login Time</b> : {{ student_details.login_time | moment("DD-MM-YYYY,hh:mm a") }}</v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex class="clsForStudentDetails"><b>Set Id</b> : {{ student_details.set_id }}</v-flex>
                            <v-flex class="clsForStudentDetails"><b>System No</b> : {{ student_details.system_no }}</v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex class="clsForStudentDetails"><b>Submit Status</b> : {{ student_details.submit_status ? 'Submited' : 'Not Submited'}}</v-flex>
                            <v-flex class="clsForStudentDetails"><b>Submit Time</b> : {{ student_details.submit_time | moment("DD-MM-YYYY,hh:mm a") }}</v-flex>
                        </v-flex>
                        <v-flex class="clsForStudentDetails"><b>Last Disconnected</b> : {{ student_details.last_disconnected | moment("DD-MM-YYYY,hh:mm a") }}</v-flex>
                    </v-card-text>
                </v-card>
            </v-dialog>
    </section>
</template>
<script>
import moment from 'moment';
export default {
  data(){
        return {
            Admins : [],
            SelectedCenter : {},
            exam_date      : new Date().toISOString().substr(0, 10),
            date_menu      : false,
            exam_list      : [],
            SelectedExam   : {},
            headers: [
                { text: "Roll No", value : "first_name"},
                { text: "Full Name", value : "last_name"},
                { text: "Exam Id", value : "exam_id"},
                { text: "Exam Time", value : "datetime"},
                { text: 'Login Time', value : "login_time"},
                { text: 'Last Disconneted', value : "last_disconnected"},
                { text: 'Submit Time', value : "submit_time"},
                { text: 'Submit Status', value : "submit_status"},
                { text: "Actions" }
            ],
            StudentList     : [],
            dialog          : false,
            student_details : {}
        }
  },
  methods:{
      customFilter (item, queryText, itemText) {
        const textOne = item.name.toLowerCase()
        const textTwo = item.abbr.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
      },
      MoreDetails(student_detail){
          this.student_details = student_detail
          this.dialog = true
      },
      CloseDialog(){
          this.student_details = {}
          this.dialog = false
      },
      GetExamList(){

          this.exam_list = []
          this.SelectedExam = {}
          this.date_menu = false
          let data = {
              "center_id" : this.SelectedCenter['center_id'],
	          "start_date" : this.exam_date
          }
          this.$eventHub.$emit("LOADING",'true')
          if(this.SelectedCenter && Object.keys(this.SelectedCenter).length > 0 && this.exam_date){

              this.$http.post(`${this.$store.getters.GetProductionUrl}/admin/getexamlist`,data)
                .then(response =>{
    
                    this.exam_list = response && response['data'] && response['data']['response'] ? response['data']['response'] : []
                    return this.$http.post(`${this.$store.getters.GetProductionUrl}/admin/getstudentlist`,{'center_id' : this.SelectedCenter['center_id'],'datetime'  : moment(this.exam_date).toISOString() })
    
                })
                .then(response =>{

                    this.StudentList = response && response['data'] && response['data']['response'] ? response['data']['response'] : []
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(error =>{

                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                })
          }else{
            this.$eventHub.$emit("LOADING",'false')
            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Select Exam Date and Center","Color":"red","Close": false });
          }
      },
      GetStudentList(){
          let data = {
              'center_id' : this.SelectedCenter['center_id'],
              'exam_id'   : this.SelectedExam['exam_id'],
              'datetime'  : moment(this.SelectedExam['start_date'] + " "+ this.SelectedExam['start_time']).toISOString()
          } 
          this.$http.post(`${this.$store.getters.GetProductionUrl}/admin/getstudentlist`,data)
                .then(response =>{
    
                    this.StudentList = response && response['data'] && response['data']['response'] ? response['data']['response'] : []
                    this.$eventHub.$emit("LOADING",'false')
    
                })
                .catch(error =>{

                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                })
      }
  },
  mounted(){

      this.$eventHub.$emit("LOADING",'true')
      this.$http.post(`${this.$store.getters.GetProductionUrl}/admin/getadminlist`,{})
            .then(response =>{

                this.Admins = response && response['data'] && response['data']['response'] ? response['data']['response'] : []
                this.$eventHub.$emit("LOADING",'false')
            })
            .catch(error =>{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
            })
  }  
}
</script>
<style scoped>
.clsForTitles{
    width: 30%; 
    padding: 15px;
    display: inline-block;
    text-align: center;
}
.clsForStudentDetails{
    width: 48%;
    padding: 5px 0px;
    display: inline-block;
}
</style>